import { FC } from "react"

export const AppFooter: FC = () => {
  return (
    <div className="bg-brand-dark w-full h-9 flex justify-center items-center fixed bottom-0">
      <span className="text-[#D1D1D1] text-tab font-normal">
        © 2022 Coherent - All rights reserved. Privacy policy Terms of use
      </span>
    </div>
  )
}

